import React from 'react'

const CreateNft = () => {
  return (
    <div>
      <h1>
      this is CreateNft</h1>
    </div>
  )
}

export default CreateNft
